import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  productCategory: {
    padding: '8px 16px',
    borderRadius: '0px !important',
    borderBottom: `1px solid ${theme.evPalette.charcoal[400]}`,
    boxShadow: 'unset',
    '&.Mui-expanded': { margin: 0 },
  },
  categoryImage: {
    display: 'inline-flex',
  },
  iconStyle: {
    height: '47px',
    width: '60px',
  },
  header: {
    display: 'flex',
    lineHeight: '24px',
    padding: '0px',
    margin: '0px',
    fontSize: '16px',
    color: theme.evPalette.ocean[700],
    '& .myev-MuiExpansionPanelSummary-content': {
      margin: '0px',
      '& .myev-MuiGrid-container': {
        gap: '10px',
      },
    },
    '& .myev-MuiExpansionPanelSummary-expandIcon.Mui-expanded': {
      transform: 'rotate(180deg)',
    },
    '&.Mui-expanded': { minHeight: 'unset' },

  },
  subHeader: {
    '& .myev-MuiTypography-body1': {
      fontSize: '14px',
    },
  },
  expandIcon: {
    '& .myev-MuiExpansionPanelSummary-expandIcon.Mui-expanded': 'rotate(90deg)',
  },
  productContainer: {
    padding: '0px',
    '& .myev-MuiRadio-root': {
      color: theme.evPalette.charcoal[500],
      padding: '0px',
      paddingRight: '6px',
    },
    '& .myev-MuiCheckbox-root': {
      color: theme.evPalette.charcoal[500],
      padding: '0px',
      paddingRight: '6px',
    },
    '& .Mui-checked': {
      color: theme.evPalette.ocean[500],
    },
    '& .products': {
      padding: '16px 0',
      cursor: 'pointer',
    },
    '& .products.disabled': {
      color: theme.evPalette.charcoal[500],
      '& .myev-MuiTypography-root': {
        color: theme.evPalette.charcoal[500],
      },
      '& .myev-MuiCheckbox-root': {
        color: theme.evPalette.charcoal[500],
      },
    },
    '& #productDelivery': {
      alignItems: 'center',
      padding: '8px 0 0 0',
    },
    '& #productDelivery .myev-MuiSelect-select:focus': {
      background: 'unset',
    },
    '& #productDelivery .myev-MuiInputBase-formControl': {
      width: '157px',
      height: '36px',
    },
    '& #productDelivery .myev-MuiTypography-root': {
      paddingLeft: '30px',
      textTransform: 'uppercase',
      fontWeight: '600',
      fontSize: '12px',
      lineHeight: '18px',
    },
  },
  alerts: {
    paddingTop: '8px',
    '& .myev-MuiAlert-root': {
      fontSize: '16px',
    },
  },
  tooltip: {
    left: '-9px',
    padding: '21px 0px 27px',
    color: '#6d6e71',
    borderRadius: '0px',
    fontSize: '14px',
    borderWidth: '1px 1px 1px 6px',
    lineHeight: '20px',
    boxShadow: 'none',
    backgroundImage: 'none',
    maxWidth: '500px',
    backgroundColor: theme.evPalette.salt[100],
    '@media (min-width: 640px)': {
      margin: '6px',
      border: '1px solid #3282D1',
      borderLeft: '6px solid #3282D1',
      flex: 1,
      padding: '21px 15px 27px',
    },

    '& #tooltipContent': {
      display: 'flex',
      flexDirection: 'row',
      marginRight: '0px',
      '@media (min-width: 640px)': {
        marginRight: '10px',
      },
    },

    '& #productImageContainer': {
      width: '140px',
      minWidth: '140px',
      height: '120px',
      marginRight: '16px',
      '@media (min-width: 640px)': {
        marginRight: '35px',
      },
    },

    '& .toolTipImageContainer': {
      marginTop: '10px',
      width: '140px',
      height: '120px',
      marginRight: '35px',
    },

    '& #textContainer': {
      lineHeight: '2',
    },

    '& .sample-report': {
      padding: '4px 4px 7px 4px',
      color: theme.evPalette.ocean[600],
      background: theme.evPalette.ocean[100],
      borderRadius: '4px',
      fontSize: '12px',
      lineHeight: '15px',
      textDecoration: 'none',
      width: 'fit-content',
      alignItems: 'center',
    },

    '& .sample-report img': {
      position: 'relative',
      top: '4px',
    },
  },
  arrow: {
    '&:before': {
      border: '1px solid #3282D1',
    },
    color: theme.evPalette.salt[100],

  },
  qsmfContainer: {
    margin: '10px',
    '& .myev-MuiAlert-root': {
      fontSize: '1rem',
    },
    '@media (max-width: 640px)': {
      display: 'none',
    },
  },
}));
